import { createContext } from 'react'

import { Data } from '@f-fertighaus/applications/RequestWizard/steps/dataType'
import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

export const QuizContext = createContext<QuizContextType | EmptyObject>({})

type EmptyObject = Record<string, never>

export interface QuizContextType {
  actions: $TSFixMe
  data: Partial<Data>
  displayCheckoutWithImage: boolean
  isNewMobileCheckoutDesign: boolean
  tileStyle: 'card' | 'bar'
  tracking: {
    flow: {
      flow_information: {
        flow_id: string
        flow_type: string
        flow_kickoff: string[]
        flow_step: number
      }
    }
  }
}
